import { Component, type ErrorInfo, type ReactNode } from "react";

import { captureException } from "../observability";

export class RenderErrorBoundary extends Component<
  { readonly children: ReactNode; readonly fallback: ReactNode },
  { readonly failed: boolean }
> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  // React render errors are swallowed by the boundary and never reach
  // window.onerror — report them to Sentry here (no-op until a DSN is set).
  override componentDidCatch(error: unknown, info: ErrorInfo) {
    captureException(error, { componentStack: info.componentStack ?? undefined });
  }

  override render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
